import { QueryKey, useQuery, UseQueryResult } from 'react-query'
import http from 'src/utils/Http'

export default function useFetch<T>(
  key: QueryKey,
  url: string,
  enabled = true
): UseQueryResult<T, unknown> {
  const query = useQuery<T>(
    key,
    async function() {
      const response = await http.get({ url, token: true })
      return response
    },
    {
      staleTime: 50,
      enabled
    }
  )
  return query
}
